import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {ListItem} from '@travel-frontend/ui-components';

type Props = {
  children: React.ReactNode;
};
export const Container = styled.div<Props>(
  ({theme}) => css`
    ${theme.typography.paragraphSmall}

    ${ListItem} {
      ${theme.typography.paragraphMedium}
    }

    svg {
      color: ${theme.colors.systemPositive};
    }

    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    gap: 16px;
  `
);
